module.exports = __webpack_public_path__ + "static/kids_friendly_school-d976bf5a85f129d64edae760088b704d.png";